import {
    USER_LOGOUT_SUCCESS,
    USER_LOGOUT_FAILURE,
    LOAD_USER_FAILURE,
    LOAD_USER_SUCCESS,
    LOAD_USER_REQUEST,
    GET_USER_NOTICE_SUCCESS,
    GET_USER_NOTICE_FAILURE,
    SEE_USER_NOTICE_SUCCESS,
    SEE_USER_NOTICE_FAILURE,
    UNAUTHORIZED_RESPONSE_ERROR,
    SET_DAILY_REPORT_FILTER_DATA,
    RESET_DAILY_REPORT_FILTER_DATA,
    SET_DENTIST_DETAILS_FILTER_DATA,
    RESET_DENTIST_DETAILS_FILTER_DATA,
    REMOVE_USER_NOTICE_SUCCESS,
    REMOVE_USER_NOTICE_FAILURE,
} from "./constants";
import {
    USER_LOGIN_FAILURE,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_REQUEST,
    RESET_LOGIN_ERROR
} from "../Layouts/Default/Signin/constants";
import {PROFILE_UPDATE_SUCCESS} from "../Layouts/User/Profile/constants";

const initialState = {
    loggedIn: undefined,
    loginError: false,
    currentUser: undefined,
    isCurrentUserLoadingSuccess: false,
    userLoading: undefined,
    validationMessage: false,
    notices: [],
    isUnAuthorized: false,
    filterData: {},
    detailsFilterData: {}
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case UNAUTHORIZED_RESPONSE_ERROR: {
            return Object.assign({}, state, {currentUser: false, loggedIn: false, validationMessage: false, isUnAuthorized: true});
        }
        case USER_LOGIN_REQUEST: {
            return Object.assign({}, state, {userLoading: true, isUnAuthorized: false, loginError: false, validationMessage: false});
        }
        case USER_LOGIN_SUCCESS: {
            return Object.assign({}, state, {currentUser: action.data, loggedIn: true, loginError: false, userLoading: false, validationMessage: false});
        }
        case USER_LOGIN_FAILURE: {
            const message = (action.data.error.message) ? 'The e-mail or password you entered is incorrect.' : action.data.error.validationErrors.error;
            return Object.assign({}, state, {loggedIn: false, loginError: true, validationMessage: message, userLoading: false });
        }
        case RESET_LOGIN_ERROR: {
            return Object.assign({}, state, { loginError: false, validationMessage: false});
        }
        case USER_LOGOUT_SUCCESS: {
            return Object.assign({}, state, {currentUser: false, loggedIn: false, validationMessage: false});
        }
        case USER_LOGOUT_FAILURE: {
            throw new Error('not implemented');
        }
        case PROFILE_UPDATE_SUCCESS: {
            let object = Object.assign({}, state.currentUser, action.data.data);
            return Object.assign({}, state, {currentUser: object});
        }
        case LOAD_USER_REQUEST: {
            return Object.assign({}, state, {isCurrentUserLoadingSuccess: false, userLoading: true});
        }
        case LOAD_USER_SUCCESS: {
            delete action.data.createdAt;
            delete action.data.password;
            delete action.data.reset_token;
            delete action.data.token;
            delete action.data.updatedAt;
            return Object.assign({}, state, {currentUser: action.data, loggedIn: true, loginError: false,isCurrentUserLoadingSuccess: true, userLoading: false});
        }
        case LOAD_USER_FAILURE: {
            return Object.assign({}, state, {notices: false,isCurrentUserLoadingSuccess: false, userLoading: false});
        }
        case GET_USER_NOTICE_SUCCESS: {
            return Object.assign({}, state, {notices: action.data, validationMessage: false});
        }
        case GET_USER_NOTICE_FAILURE: {
            return Object.assign({}, state, {notices: [], validationMessage: false});
        }
        case SEE_USER_NOTICE_SUCCESS: {
            return Object.assign({}, state, {notices: action.data, validationMessage: false});
        }
        case SEE_USER_NOTICE_FAILURE: {
            return Object.assign({}, state, {notices: [], validationMessage: false});
        }
        case SET_DAILY_REPORT_FILTER_DATA: {
            return Object.assign({}, state, {filterData: action.data});
        }
        case RESET_DAILY_REPORT_FILTER_DATA: {
            return Object.assign({}, state, {filterData: {}});
        }
        case SET_DENTIST_DETAILS_FILTER_DATA: {
            return Object.assign({}, state, {detailsFilterData: action.data});
        }
        case RESET_DENTIST_DETAILS_FILTER_DATA: {
            return Object.assign({}, state, {detailsFilterData: {}});
        }
        case REMOVE_USER_NOTICE_SUCCESS: {
            return Object.assign({}, state, {notices: [], validationMessage: false});
        }
        case REMOVE_USER_NOTICE_FAILURE: {
            return Object.assign({}, state, {validationMessage: false});
        }
        default:
            return state;
    }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/containers/AuthWrapper/reducer.js